import { render, staticRenderFns } from "./PersonAvatar.vue?vue&type=template&id=57879cbc&scoped=true"
import script from "./PersonAvatar.vue?vue&type=script&lang=js"
export * from "./PersonAvatar.vue?vue&type=script&lang=js"
import style0 from "./PersonAvatar.vue?vue&type=style&index=0&id=57879cbc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57879cbc",
  null
  
)

export default component.exports